module.exports = __webpack_public_path__ + "img/ph-seal-check.a6716502.svg";